import React from 'react';
import { Route, Routes } from 'react-router-dom';
import MetaAdsAnalytics from './Components/MetaAdsAnalytics';
// In your router configuration file
import AdDetailAnalytics from './Components/AdDetailAnalytics';
import CreateMetaAd from './Components/CreateMetaAd';
// Add this route
// import SequencesPage from './Components/Sequences';
// import CreateSequencePage from './Components/CreateSequence';
// import LinkedinSequenceAnalytics from './Components/LinkedinSequenceAnalytics';
const MetaAds = () => {
  return (
    <Routes>
      <Route path="/" element={<MetaAdsAnalytics />} />
<Route path="analytics/:adId" element={<AdDetailAnalytics />} />
<Route path="/create/:adId" element={<CreateMetaAd />} />
      {/* <Route path="/create" element={<CreateSequencePage />} />
      <Route path='analytics/:id' element={<LinkedinSequenceAnalytics />} ></Route> */}
    </Routes>
  );
};

export default MetaAds;